import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';
import handlePurchase from "@/services/modules/purchase";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const pdfPrinter = () => {
    const store = useStore();
    const {commaFormat} = figureFormatter();
    const {getHeader, getFooter} = pdfHeaderFooter();
    const { currencyToWord } = handlePurchase();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, payHeads, payrollStatement, payrollStatementData, payrollStatementSummary, payrollAdvice, finalSettlement = false) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [30, 100, 30, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(payHeads, payrollStatement, payrollStatementData, payrollStatementSummary, payrollAdvice, finalSettlement),

            styles: {
                header: {
                    fontSize: 20,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 11,
                font: 'SulaimanLipi'
            },

            info: {
                title: 'Payslip' + (finalSettlement ? '(Final Settlement)' : '')
            }
        }

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (payHeads, payrollStatement, payrollStatementData, payrollStatementSummary, payrollAdvice, finalSettlement) => {
        return [
            {
                text: 'Payslip' + (finalSettlement ? '(Final Settlement)' : ''),
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 5, 5],
                bold: true,
                color: 'black',
                fontSize: 12,
            },
            {
                text: 'For The Month Of ' + payrollStatement.payroll_month || '',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 5, 5],
                bold: true,
                color: 'black',
                fontSize: 12,
            },

            {
                margin: [5, 20, 5, 5],
                columns: [
                    {   width: '50%',
                        stack: [
                            {
                                text: `Pay Period:` + payrollStatement.start_date + ' to ' + payrollStatement.end_date,
                                margin: [0, 0, 0, 5]
                            },

                            {
                                text: `Employee ID: ${payrollStatementData.serial_no}`,
                                margin: [0, 0, 0, 5]
                            },

                            {
                                text: `Employee Name: ${payrollStatementData.name}`,
                                margin: [0, 0, 0, 5]
                            },

                            {
                                text: `Designation: ${payrollStatementData.designation}`,
                                margin: [0, 0, 0, 5]
                            },
                        ]
                    },

                    {
                        width: '50%',
                        alignment: 'left',
                        stack: [
                            {
                                text: `Issue Date: ${payrollStatement.payslip_issue_date}`,
                                margin: [0, 0, 0, 5]
                            },
                            {
                                text: `Joining Date : ${payrollStatementData.joining_date}`,
                                margin: [0, 0, 0, 5]
                            },
                            {
                                text: `Department: ${payrollStatementData.department}`,
                                margin: [0, 0, 0, 5]
                            },

                        ]
                    },
                ]
            },

            {
                margin: [5, 20, 5, 5],
                columns: [

                        {
                            width: '48%',
                            stack: [
                                {text: 'Earnings', bold:true,},
                                {
                                    style: 'tableExample',
                                    margin: [0, 10, 0, 0],
                                    table: {
                                        widths: ['70%', '30%'],
                                        body: buildEarningTable(payHeads, payrollStatementData)
                                    },
                                    layout: {
                                        fillColor: function (rowIndex, node, columnIndex) {
                                            return (rowIndex === 0) ? '#f3f2f7' : null;
                                        },
                                        hLineWidth: function (i, node) {
                                            return 0.5;
                                        },
                                        vLineWidth: function (i, node) {
                                            return 0.5;
                                        }
                                    }
                                },

                            ]
                        },
                    {
                        width: '4%',
                        text: ''
                    },
                     {
                            width: '48%',
                            stack: [
                                { text: 'Deductions', bold:true },
                                {
                                    style: 'tableExample',
                                    margin: [0, 10, 0, 0],
                                    table: {
                                        widths: ['70%', '30%'],
                                        body: buildDeductionTable(payHeads, payrollStatementData)
                                    },
                                    layout: {
                                        fillColor: function (rowIndex, node, columnIndex) {
                                            return (rowIndex === 0) ? '#f3f2f7' : null;
                                        },
                                        hLineWidth: function (i, node) {
                                            return 0.5;
                                        },
                                        vLineWidth: function (i, node) {
                                            return 0.5;
                                        }
                                    }
                                },
                            ]
                        }
                ]
            },

            {
                margin: [5, 20, 5, 5],
                columns: [
                    {
                        width: '48%',
                        stack: [
                            {
                                text: `Net Payable: ` + commaFormat(payrollStatementSummary.total_net_payable) || 0,
                                bold: true,
                                margin: [0, 0, 0, 5]
                            },
                            {
                                text: payrollStatementSummary.total_net_payable
                                    ? 'In Words: ' + currencyToWord(payrollStatementSummary.total_net_payable, false, false, 2)
                                    : '',
                                margin: [0, 0, 0, 5]
                            },
                        ]
                    },
                    {
                        width: '4%',
                        text: ''
                    },
                    {
                        width: '48%',
                        stack: [
                            { text: 'Payment Advice', bold:true },
                            {
                                style: 'tableExample',
                                margin: [0, 10, 0, 0],
                                table: {
                                    widths: ['40%', '30%', '30%'],
                                    body: buildPaymentAdviceTable(payrollAdvice)
                                },
                                layout: {
                                    fillColor: function (rowIndex, node, columnIndex) {
                                        return (rowIndex === 0) ? '#f3f2f7' : null;
                                    },
                                    hLineWidth: function (i, node) {
                                        return 0.5;
                                    },
                                    vLineWidth: function (i, node) {
                                        return 0.5;
                                    }
                                }
                            },
                        ]
                    }
                ]
            },

            formatSignatureData()
        ]
    }

    function buildEarningTable(payHeads, payrollStatementData) {
        let body = [];

        body.push([
            { text: 'Pay Head', bold: true, fillColor: '#f3f2f7' },
            { text: 'Amount', alignment: 'right', bold: true, fillColor: '#f3f2f7' }
        ]);

        if (payrollStatementData.gross_earnings) {
            Object.entries(payrollStatementData.gross_earnings).forEach(([headId, amount]) => {
                const head = payHeads.gross.find(h => h.id == headId);
                if (head) {
                    body.push([
                        { text: head.name },
                        { text: commaFormat(amount), alignment: 'right' }
                    ]);
                }
            });
        }

        if (payrollStatementData.other_earnings) {
            Object.entries(payrollStatementData.other_earnings).forEach(([headId, amount]) => {
                const head = payHeads.earning.find(h => h.id == headId);
                if (head) {
                    body.push([
                        { text: head.name },
                        { text: commaFormat(amount), alignment: 'right' }
                    ]);
                }
            });
        }

        body.push([
            { text: 'Total', bold: true },
            { text: commaFormat(payrollStatementData.total_earning), bold: true, alignment: 'right' }
        ]);

        return body;
    }

    function buildDeductionTable(payHeads, payrollStatementData) {
        let body = [];

        body.push([
            { text: 'Pay Head', bold: true, fillColor: '#f3f2f7' },
            { text: 'Amount', alignment: 'right', bold: true, fillColor: '#f3f2f7' }
        ]);

        if (payrollStatementData.deductions) {
            Object.entries(payrollStatementData.deductions).forEach(([headId, amount]) => {
                const head = payHeads.deduction.find(h => h.id == headId);
                if (head) {
                    body.push([
                        { text: head.name },
                        { text: commaFormat(amount), alignment: 'right' }
                    ]);
                }
            });
        }

        body.push([
            { text: 'Total', bold: true },
            { text: commaFormat(payrollStatementData.total_deduction), bold: true, alignment: 'right' }
        ]);

        return body;
    }

    function buildPaymentAdviceTable(payrollAdvice) {
        let body = [];

        body.push([
            { text: 'Mode Of Payment', bold: true, fillColor: '#f3f2f7' },
            { text: 'Payment Date', bold: true, fillColor: '#f3f2f7' },
            { text: 'Amount', alignment: 'right', bold: true, fillColor: '#f3f2f7' }
        ]);

        if (payrollAdvice) {
             payrollAdvice.forEach((item) => {
                body.push([
                    { text: item.payment_mode_name },
                    { text: item.payment_date },
                    { text: commaFormat(item.paid_amount), alignment: 'right' }
                ]);
            });
        }

        return body;
    }

    const formatSignatureData = () => {

        let signatures = [ 'Prepared By', 'Checked By', 'Approved By' ];

        return {
            alignment: 'justify',
            absolutePosition: { x: 60, y: 740 },
            columns: signatures.map(getSingleSignature)
        }
    }

    const getSingleSignature = (title) => {
        return {
            width: '43%',
            stack: [
                {
                    canvas: [
                        {
                            type: 'line',
                            x1: 0,
                            y1: 0,
                            x2: 58,
                            y2: 0,
                            lineWidth: 1
                        }
                    ]
                },
                {
                    margin: [ 0, 5, 0, 0 ],
                    text: `${title} `,
                    color: 'black',
                    bold: true,
                    alignment: 'left',
                }
            ]
        }
    }

    return {
        exportToPDF
    }
}

export default pdfPrinter;